export default __webpack_public_path__ + "static/media/img8.d44cd74e.jpg";